export default __webpack_public_path__ + "static/media/60_photo.97d0fcbe.jpg";